import React, { useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';

interface IDocumentItemProps {
  title: string;
  description?: string;
  fileUrl: string;
  fileName: string;
}

const DocumentItem = ({ title, description, fileUrl, fileName }: IDocumentItemProps) => {

  const handleDownload = useCallback(async () => {
    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
        credentials: 'include',
      });

      if (!response.ok) {
        const error = await response.text();
        console.error('Download failed:', response.status, error);
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Download error:', error);
    }
  }, [fileUrl, fileName]);

  return (
    <Box className="documentItem" onClick={handleDownload} sx={{ cursor: 'pointer' }}>
      <PictureAsPdfIcon className="documentItemIcon" />

      <Box className="documentItemText">
        <Typography variant="subtitle1" className="documentItemTitle">
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" className="documentItemDescription">
            {description}
          </Typography>
        )}
      </Box>

      <Box className="documentItemDownload">
        <DownloadIcon />
      </Box>
    </Box>
  );
};

export default DocumentItem;